<section class="type-table">
  <div style="display: inline-block">
    <ul class="diamonds">
      <li *ngFor="let mbtiType of mbtiTypes | slice: 0 : 4">
        <div role="button" class="diamond" [ngClass]="{ activeType: isActiveType(mbtiType) }">
          <div class="diamond-content" [ngClass]="{ 'has-type': teamTypes.has(mbtiType) }">
            {{ mbtiType }}
            <div [innerHTML]="initialsByType[mbtiType]"></div>
          </div>
        </div>
      </li>
    </ul>
    <ul class="diamonds">
      <li *ngFor="let mbtiType of mbtiTypes | slice: 4 : 8">
        <div role="button" class="diamond" [ngClass]="{ activeType: isActiveType(mbtiType) }">
          <div class="diamond-content" [ngClass]="{ 'has-type': teamTypes.has(mbtiType) }">
            {{ mbtiType }}
            <div [innerHTML]="initialsByType[mbtiType]"></div>
          </div>
        </div>
      </li>
    </ul>
    <ul class="diamonds">
      <li *ngFor="let mbtiType of mbtiTypes | slice: 8 : 12">
        <div role="button" class="diamond" [ngClass]="{ activeType: isActiveType(mbtiType) }">
          <div class="diamond-content" [ngClass]="{ 'has-type': teamTypes.has(mbtiType) }">
            {{ mbtiType }}
            <div [innerHTML]="initialsByType[mbtiType]"></div>
          </div>
        </div>
      </li>
    </ul>
    <ul class="diamonds">
      <li *ngFor="let mbtiType of mbtiTypes | slice: 12 : 16">
        <div role="button" class="diamond" [ngClass]="{ activeType: isActiveType(mbtiType) }">
          <div class="diamond-content" [ngClass]="{ 'has-type': teamTypes.has(mbtiType) }">
            {{ mbtiType }}
            <div [innerHTML]="initialsByType[mbtiType]"></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</section>
